var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H0V3.5H0.75V7V12V12.75H1.5H4V13.5H7V10.5H4V11.25H2.25V7.75H4V8.5H7V5.5H4V6.25H2.25V3.5H3V0.5ZM5 1V3H6H15H16V1H15H6H5ZM9 6V8H10H15H16V6H15H10H9ZM9 11V13H10H15H16V11H15H10H9Z",
    fill: "#BCD4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryTask);
export default __webpack_public_path__ + "static/media/category_task.70ebb0960eab35996f2cabaf137d5a3b.svg";
export { ForwardRef as ReactComponent };